import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    const cleanEmail = email.trim().toLowerCase();
    const cleanPw = password;
    if (!cleanEmail || !cleanPw) {
      setErr("E-posta ve şifre zorunludur.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", {
        email: cleanEmail,
        password: cleanPw,
      });
      localStorage.setItem("life101_admin_token", data.token);
      localStorage.setItem("life101_admin_email", data.email);
      nav("/admin");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Giriş bilgileri hatalı veya bu hesaba admin yetkisi verilmemiş.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#050505" }} data-testid="admin-login-page">
      <form onSubmit={submit} className="glass p-10 w-full max-w-md">
        <h1 className="text-3xl font-semibold h-gradient">Life 101 Admin</h1>
        <p className="mt-2 text-sm text-neutral-500">Yönetici hesabınla giriş yap.</p>

        <div className="mt-8 space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">E-posta</label>
            <input
              type="email"
              autoComplete="username"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
              className="life-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@life101.com"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">Şifre</label>
            <div className="relative">
              <input
                type={show ? "text" : "password"}
                autoComplete="current-password"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck={false}
                className="life-input pr-10"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
              />
              <button
                type="button"
                onClick={() => setShow((s) => !s)}
                className="absolute right-1 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-white p-1"
                aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}
                data-testid="toggle-password"
              >
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
        </div>

        {err && <div className="mt-5 text-sm text-red-300/80" data-testid="admin-error">{err}</div>}

        <button type="submit" disabled={loading} className="btn-primary mt-7 w-full" data-testid="admin-login-submit">
          {loading ? "Giriş yapılıyor..." : "Admin Girişi"}
        </button>

        <p className="mt-6 text-xs text-neutral-600 text-center leading-relaxed">
          Şifrede büyük <span className="text-neutral-300">L</span>, sayılar ve <span className="text-neutral-300">!</span> karakteri olduğuna dikkat et. Mobilde otomatik düzeltme şifreyi bozabilir.
        </p>
      </form>
    </div>
  );
}
